import React from 'react';
import './SearchInput.css'
import '../../root.css'

const SearchInput = (props) => {
    return ( 
        <input className='SearchInput' type="text" placeholder={props.InputText}/>
     );
}
 
export default SearchInput;